import { styled } from '@mui/material'
import { CircleTickIcon, CircleMailIcon, CircleHeartIcon } from '../Icons'
import ProcessStep from './ProcessStep'
import { MAX_ENQUIRY_RESPONSES } from '../../../../Constants'

const StyledList = styled('ol')(({ theme }) => ({
  listStyle: 'none',
  textAlign: 'center',
  margin: 0,
  marginBlock: 0,
  marginInline: 0,
  padding: 0,
  'li ~ li': {
    marginTop: 32,
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      marginLeft: 32,
    },
  },
}))

export interface ProcessStepsProps {
  isDirectEnquiry: boolean
  venueName: string
}

const ProcessSteps = ({
  isDirectEnquiry,
  venueName,
}: ProcessStepsProps): JSX.Element => (
  <StyledList role='list'>
    <ProcessStep
      icon={<CircleTickIcon aria-hidden='true' />}
      title={'We’ve got your enquiry'}
    >
      {isDirectEnquiry
        ? `We've shared it with ${venueName} and other suitable venues, so you have the best chance of finding the right space.`
        : "Thanks for telling us what you're looking for. We have shared your enquiry with suitable venues."}
    </ProcessStep>
    <ProcessStep
      icon={<CircleMailIcon aria-hidden='true' />}
      title={`Get messages from up to ${MAX_ENQUIRY_RESPONSES} venues`}
    >
      We’ll email you when you get messages from venues and you can view them on
      this page.
    </ProcessStep>
    <ProcessStep
      icon={<CircleHeartIcon aria-hidden='true' />}
      title={'Match or decline'}
    >
      Match with venues you like or decline to hear from others. When you match
      venues will be in touch directly to discuss further.
    </ProcessStep>
  </StyledList>
)

export default ProcessSteps
